import { IdModal } from "../../../../modals/IdModal";
import { createPathSelectTabInModal } from "../../../path/createPathSelectTabInModal";
export var pathSelectMainTabInLibraryMenu = function (action, state$, deps) { return createPathSelectTabInModal(function () { return IdModal.Library; })(action, state$, deps); };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/buy-improvement/paths/pathSelectMainTabInLibraryMenu.ts
// module id = 2354
// module chunks = 3